




import { Component } from "vue-property-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";
import { getCurrencyMask } from "@share/common/form/form-controls/text/masks";
import { MaskedPattern } from "imask"

@Component({})

export default class BorderlessText extends BaseBorderless {

    mask: MaskedPattern<string> | null = null;

    mounted() {
        const mask = this.mask = getCurrencyMask();
        mask.resolve(this.value || "");
    }

    get model() {
        return this.mask?.value;
    }

    set model(value) {
        this.mask?.resolve(value || "")
        this.$emit('input', this.mask?.unmaskedValue);
    }
}
